import { generateURL, showMobileFilterButton } from "./offers";
import { ACTUAL_FILTER } from "./settings";

$(() => {
  $("#isTeleworking a").removeAttr('href');

  $(document).on("click", "#isTeleworking input[type=radio][name=isTeleworking]", () => {
    const radioValue: number = +$(
      "#isTeleworking input[type=radio][name=isTeleworking]:checked"
    ).val()!;

    if (radioValue === null || radioValue === 0) {
      ACTUAL_FILTER.isTeleworking = null;
    } else {
      ACTUAL_FILTER.isTeleworking = radioValue === 2;
    }
    window.innerWidth > 767
      ? generateURL()
      : showMobileFilterButton();
  });
});
